<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" id="_idContainer006" role="doc-dedication">
<p class="pl-center">Dedicated to my fabulous agent, Michelle Grajkowski, who is always there for meand who never loses faith in me.</p>
<p class="pl-center">And to my wonderful writer friends who are always willing to help me brainstorm my way out of sticky plot scenarios—Amy, Christopher, Dustin and Renee.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?5b359d3a